module.exports = __webpack_public_path__ + "static/media/a-continuum-sample.1396da6f.png";